import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import VueCompositionAPI from '@vue/composition-api'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMq from "vue-mq";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(VueCompositionAPI);

Vue.use(VueMq, {
  breakpoints: {
    iPad: 1025,
    iPadPro: Infinity,
  },
  defaultBreakpoint: 'iPad'
});

//////////////////////
// Solriamfetol Data
//////////////////////

// Bar data sets
import * as tones3AEIanxiety from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-anxiety';
import * as tones3AEIappetite from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-appetite';
import * as tones3AEIheadache from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-headache';
import * as tones3AEIinsomnia from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-insomnia';
import * as tones3AEIjittery from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-jittery';
import * as tones3AEInausea from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-incidence-nausea';
import * as tones3Cgic from '../../jazz-components/src/chart-data/tones-3/tones-3-cgic';
import * as tones3Fosq10 from '../../jazz-components/src/chart-data/tones-3/tones-3-fosq10';
import * as tones3Pgic from '../../jazz-components/src/chart-data/tones-3/tones-3-pgic';
import * as tones3WpaiAbs from '../../jazz-components/src/chart-data/tones-3/tones-3-wpai-abs';
import * as tones3WpaiActimp from '../../jazz-components/src/chart-data/tones-3/tones-3-wpai-actimp';
import * as tones3WpaiPres from '../../jazz-components/src/chart-data/tones-3/tones-3-wpai-pres';
import * as tones3WpaiWorkimp from '../../jazz-components/src/chart-data/tones-3/tones-3-wpai-workimp';
import * as tones324hDbp from '../../jazz-components/src/chart-data/tones-3/tones-3-24h-dbp';
import * as tones324hSbp from '../../jazz-components/src/chart-data/tones-3/tones-3-24h-sbp';
import * as tones3EssMitt from '../../jazz-components/src/chart-data/tones-3/tones-3-ess-mitt';
import * as tones3MwtIndiv from '../../jazz-components/src/chart-data/tones-3/tones-3-mwt-indiv';
import * as tones3MwtMitt from '../../jazz-components/src/chart-data/tones-3/tones-3-mwt-mitt';
import * as tones3AeDuration from '../../jazz-components/src/chart-data/tones-3/tones-3-ae-duration';
import * as tones3AesTeaes from '../../jazz-components/src/chart-data/tones-3/tones-3-aes-teaes';
import * as tones3BaselineChar from '../../jazz-components/src/chart-data/tones-3/tones-3-baseline-char';
import * as tones3BpHr from '../../jazz-components/src/chart-data/tones-3/tones-3-bp-hr';
import * as tones3CpapAdh from '../../jazz-components/src/chart-data/tones-3/tones-3-cpap-adh';
import * as tones3Summary from '../../jazz-components/src/chart-data/tones-3/tones-3-summary';
import * as tones3StudyDesign from '../../jazz-components/src/chart-data/tones-3/tones-3-study-design';
import * as tones3ParticipantDisposition from '../../jazz-components/src/chart-data/tones-3/tones-3-participant-disposition';

import * as tones5PgicCgic from '../../jazz-components/src/chart-data/tones-5/tones-5-pgic-cgic';
import * as tones5EssGroupA from '../../jazz-components/src/chart-data/tones-5/tones-5-ess-groupa';
import * as tones5EssGroupB from '../../jazz-components/src/chart-data/tones-5/tones-5-ess-groupb';
import * as tones5EssMittRwp from '../../jazz-components/src/chart-data/tones-5/tones-5-ess-mitt-rwp';
import * as tones5BaselineChar from '../../jazz-components/src/chart-data/tones-5/tones-5-baseline-char';
import * as tones5CpapAdh from '../../jazz-components/src/chart-data/tones-5/tones-5-cpap-adh';
import * as tones5ParticipantDis from '../../jazz-components/src/chart-data/tones-5/tones-5-participant-disposition';
import * as tones5StudyDesign from '../../jazz-components/src/chart-data/tones-5/tones-5-study-design';
import * as tones5Summary from '../../jazz-components/src/chart-data/tones-5/tones-5-summary';
import * as tones5Teaes from '../../jazz-components/src/chart-data/tones-5/tones-5-teaes';

import * as drivingSdlpAnalysis from '../../jazz-components/src/chart-data/driving/driving-sdlp-analysis';
import * as drivingSdlpIndiv from '../../jazz-components/src/chart-data/driving/driving-sdlp-indiv';
import * as drivingPerImprove from '../../jazz-components/src/chart-data/driving/driving-percent-improvement';
import * as drivingBaseline from '../../jazz-components/src/chart-data/driving/driving-baseline-char';
import * as drivingSdlp from '../../jazz-components/src/chart-data/driving/driving-sdlp-assessment-scale';
import * as drivingSecondary from '../../jazz-components/src/chart-data/driving/driving-secondary-endpts';
import * as drivingDesign from '../../jazz-components/src/chart-data/driving/driving-study-design';
import * as drivingTeaes from '../../jazz-components/src/chart-data/driving/driving-teaes';

import * as itcCgic from '../../jazz-components/src/chart-data/itc/itc-cgi-c';
import * as itcEss from '../../jazz-components/src/chart-data/itc/itc-ess';
import * as itcMwt from '../../jazz-components/src/chart-data/itc/itc-mwt';
import * as itcPatientChar from '../../jazz-components/src/chart-data/itc/itc-patient-char';
import * as itcStudyChar from '../../jazz-components/src/chart-data/itc/itc-study-char';
import * as itcDesign from '../../jazz-components/src/chart-data/itc/itc-study-design';
import * as itcTeaeRiskDiff from '../../jazz-components/src/chart-data/itc/itc-teae-risk-diff';

const trials = {
  'tones-3': {
    // bars
    'tones-3-ae-incidence-anxiety': tones3AEIanxiety.default,
    'tones-3-ae-incidence-appetite': tones3AEIappetite.default,
    'tones-3-ae-incidence-headache': tones3AEIheadache.default,
    'tones-3-ae-incidence-insomnia': tones3AEIinsomnia.default,
    'tones-3-ae-incidence-jittery': tones3AEIjittery.default,
    'tones-3-ae-incidence-nausea': tones3AEInausea.default,
    'tones-3-cgic': tones3Cgic.default,
    'tones-3-fosq10': tones3Fosq10.default,
    'tones-3-pgic': tones3Pgic.default,
    'tones-3-wpai-abs': tones3WpaiAbs.default,
    'tones-3-wpai-actimp': tones3WpaiActimp.default,
    'tones-3-wpai-pres': tones3WpaiPres.default,
    'tones-3-wpai-workimp': tones3WpaiWorkimp.default,
    // lines
    'tones-3-24h-dbp': tones324hDbp.default,
    'tones-3-24h-sbp': tones324hSbp.default,
    'tones-3-ess-mitt': tones3EssMitt.default,
    'tones-3-mwt-indiv': tones3MwtIndiv.default,
    'tones-3-mwt-mitt': tones3MwtMitt.default,
    // designs and tables
    'tones-3-ae-duration': tones3AeDuration.default,
    'tones-3-aes-teaes': tones3AesTeaes.default,
    'tones-3-baseline-char': tones3BaselineChar.default,
    'tones-3-bp-hr': tones3BpHr.default,
    'tones-3-cpap-adh': tones3CpapAdh.default,
    'tones-3-summary': tones3Summary.default,
    'tones-3-study-design': tones3StudyDesign.default,
    'tones-3-participant-disposition': tones3ParticipantDisposition.default
  },
  'tones-5': {
    'tones-5-pgic-cgic': tones5PgicCgic.default,
    'tones-5-ess-groupa': tones5EssGroupA.default,
    'tones-5-ess-groupb': tones5EssGroupB.default,
    'tones-5-ess-mitt-rwp': tones5EssMittRwp.default,
    // designs and tables
    'tones-5-baseline-char': tones5BaselineChar.default,
    'tones-5-cpap-adh': tones5CpapAdh.default,
    'tones-5-participant-disposition': tones5ParticipantDis.default,
    'tones-5-study-design': tones5StudyDesign.default,
    'tones-5-summary': tones5Summary.default,
    'tones-5-teaes': tones5Teaes.default,
  },
  'driving': {
    // dotplots
    'driving-sdlp-indiv': drivingSdlpIndiv.default,
    // designs and tables
    'driving-sdlp-analysis': drivingSdlpAnalysis.default,
    'driving-percent-improvement': drivingPerImprove.default,
    'driving-baseline-char': drivingBaseline.default,
    'driving-sdlp-assessment-scale': drivingSdlp.default,
    'driving-secondary-endpts': drivingSecondary.default,
    'driving-study-design': drivingDesign.default,
    'driving-teaes': drivingTeaes.default,
  },
  'itc': {
    // designs and tables
    'itc-cgi-c': itcCgic.default,
    'itc-ess': itcEss.default,
    'itc-mwt': itcMwt.default,
    'itc-patient-char': itcPatientChar.default,
    'itc-study-char': itcStudyChar.default,
    'itc-study-design': itcDesign.default,
    'itc-teae-risk-diff': itcTeaeRiskDiff.default,
  },
}

// Data Viz Component imports
import ChartDataService from '../../jazz-components/src/services/ChartDataService';
import BarChart from '../../jazz-components/src/components/BarChart.vue';
import LineChart from '../../jazz-components/src/components/LineChart.vue';
import DotplotChart from '../../jazz-components/src/components/DotplotChart.vue';
import BoxplotChart from '../../jazz-components/src/components/BoxplotChart.vue';
import { TooltipDirective } from '../../jazz-components/src/components/Tooltip.directive';

Vue.prototype.$chartDataService = new ChartDataService(trials);
Vue.component('BarChart', BarChart);
Vue.component('LineChart', LineChart);
Vue.component('DotplotChart', DotplotChart);
Vue.component('BoxplotChart', BoxplotChart);
Vue.directive('tooltip', TooltipDirective);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

import { patchResizeObserver } from "./polyfills";

patchResizeObserver();
